const MONET_URL = '//monet-prtl-co.imgix.net/Endor/ACT/';
const TYPEFORM_URL = 'https://studyportals.typeform.com/to/aAxmBEmy';
const FAQ_URL = 'https://studyportals.com/for-institutions/data-and-insights/frequently-asked-questions-about-migration/';

export { MONET_URL, TYPEFORM_URL, FAQ_URL };